import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SalesUserState } from './sales-user.reducer';

export const selectSalesUserState = createFeatureSelector<SalesUserState>('salesUser');

export const selectAllSalesUsers = createSelector(
  selectSalesUserState,
  (state) => state.salesUsers
);

export const selectSalesUserError = createSelector(
  selectSalesUserState,
  (state) => state.error
);

export const selectCurrentSalesUser = createSelector(
  selectSalesUserState,
  (state) => state.currentSalesUser
);
